var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMaster(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 41,
    height: 40,
    viewBox: "0 0 41 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M40.3331 20.834C40.3331 27.7375 34.7949 33.334 27.9632 33.334C21.1315 33.334 15.5933 27.7375 15.5933 20.834C15.5933 13.9304 21.1315 8.33398 27.9632 8.33398C34.7949 8.33398 40.3331 13.9304 40.3331 20.834V20.834Z",
    fill: "#F79F1A"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M25.0729 20.834C25.0729 27.7375 19.5347 33.334 12.7029 33.334C5.87121 33.334 0.333008 27.7375 0.333008 20.834C0.333008 13.9304 5.87121 8.33398 12.7029 8.33398C19.5347 8.33398 25.0729 13.9304 25.0729 20.834V20.834Z",
    fill: "#E60019"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M20.3331 10.9941C17.4469 13.2825 15.5942 16.8384 15.5942 20.8331C15.5942 24.8277 17.4469 28.3864 20.3331 30.6747C23.2194 28.3864 25.072 24.8277 25.072 20.8331C25.072 16.8384 23.2194 13.2825 20.3331 10.9941V10.9941Z",
    fill: "#FF5700"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMaster);
export default __webpack_public_path__ + "static/media/master.2d36e2654a28ea99929cc2aa96d2200a.svg";
export { ForwardRef as ReactComponent };